import { useRef } from 'react'
import { CalendarBlank, X } from '@phosphor-icons/react'
import { useUser } from '../../api/reference'
import { boardDay } from '../../model/payoutBoard'

/** The boards' day button ("Thu 2 Oct · all villages"): opens the date picker; ✕ clears it. */
export function DayButton({ day, onChange }: { day: string; onChange: (day: string) => void }) {
  const ref = useRef<HTMLInputElement>(null)
  const open = () => {
    const el = ref.current
    if (!el) return
    try {
      el.showPicker()
    } catch {
      el.focus()
    }
  }
  return (
    <span className="relative inline-flex items-center">
      <button
        type="button"
        onClick={open}
        className="inline-flex h-10 items-center gap-2 rounded-chip border-[1.5px] border-[#8a827a] bg-surface px-[14px] text-[15px] font-bold hover:bg-paper-tint"
      >
        <CalendarBlank aria-hidden="true" size={18} />
        <span>{day ? boardDay(day) : 'All days'} · all villages</span>
      </button>
      <input
        ref={ref}
        type="date"
        aria-label="Collection day"
        value={day}
        onChange={(e) => onChange(e.target.value)}
        className="pointer-events-none absolute bottom-0 left-0 h-px w-px opacity-0"
        tabIndex={-1}
      />
      {day && (
        <button type="button" aria-label="All days" onClick={() => onChange('')} className="ml-1 rounded-full p-1.5 text-muted hover:bg-paper-tint hover:text-ink">
          <X aria-hidden="true" size={16} />
        </button>
      )}
    </span>
  )
}

/** "F-019" — the farmer's roster number (looked up once, cached). */
export function FarmerCode({ id }: { id: string | null | undefined }) {
  const q = useUser(id ?? null)
  return <>{q.data?.farmerCode ?? '—'}</>
}

/** The farmer's own phone, last four digits only. */
export function FarmerPhone({ id }: { id: string | null | undefined }) {
  const q = useUser(id ?? null)
  const c = q.data?.contactNo
  return <>{c ? `••••${c.slice(-4)}` : 'his phone'}</>
}
